import { Component, Input } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-custom-checkbox',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './custom-checkbox.component.html',
  styleUrl: './custom-checkbox.component.scss'
})
export class CustomCheckboxComponent {
  @Input() label: string = "";
  @Input() binding: any;

  public uniqueId = "";

  constructor() {
    this.uniqueId = Math.random().toString(36).slice(2, 10);
  }
}
